import { render, staticRenderFns } from "./UserObjectiveView.vue?vue&type=template&id=aa084ce8&"
import script from "./UserObjectiveView.vue?vue&type=script&lang=js&"
export * from "./UserObjectiveView.vue?vue&type=script&lang=js&"
import style0 from "./UserObjectiveView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports